module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-7-aa1a727ea8059b048e26a4a283db1a04.svg";